import { Component, OnInit, Output, Input, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { ExpressionService, ExpressioneditorComponent, ComputeRuleEditorComponent, ExprEditMode } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { TypeConverter } from '@farris/ide-property-panel';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-expression-editor',
  templateUrl: './expression-editor.component.html',
  styleUrls: ['./expression-editor.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class ExpressionEditorComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input() value: string;

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  @Input() editorParams: any = {};

  @ViewChild(ExpressioneditorComponent) editor: ExpressioneditorComponent;
  @ViewChild('compute') compute: ComputeRuleEditorComponent;

  contextEntities = [];

  schema: any = {};
  injectName = '';
  modalConfig = {
    title: this.localePipe.transform('component.expressionEditor.expressionEditor'),
    width: 1036,
    height: 530,
    showButtons: true
  };

  constructor(
    private expr: ExpressionService,
    public designerState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    if (this.designerState.schemas[0]) {
      this.schema = this.designerState.schemas[0];
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        this.injectName = this.designerState.schemas[0].entityTypes[0].name;
      }
    }
  }

  ngOnInit() {
    this.contextEntities = new Array();
    if (this.designerState.procInstContext.length > 0) {
      for (const variable of this.designerState.procInstContext) {
        this.contextEntities = this.contextEntities.concat([variable]);
      }
    }
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.formalParameterContext.length > 0) {
      for (const variable of this.designerState.formalParameterContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.participantContext.length > 0) {
      for (const variable of this.designerState.participantContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.activityComponentContext.length > 0) {
      for (const variable of this.designerState.activityComponentContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
    if (this.designerState.processVariableContext.length > 0) {
      for (const variable of this.designerState.processVariableContext) {
        if (!this.contextEntities.some(c => c.key === variable.key)) {
          this.contextEntities = this.contextEntities.concat([variable]);
        }
      }
    }
  }

  clickOK() {
    const result = this.compute.getExpr();
    this.value = this.convertToValue(result.text);
    const object = { value: this.value, parameters: null };
    this.submitModal.emit(object);
  }

  /**
   * 切换表达式类型（简易表达式<--->高级表达式）
   */
  changeType() {
    this.compute.changeType();
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private convertToValue(val: string): string {
    if (val) {
      if (val.substring(9, val.length - 2)) {
        return val;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}
export class ExpressionEditorConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any): string {
    if (data) {
      return data;
    } else {
      return this.localePipe.transform("component.expressionEditor.notSet");
    }
  }
}
